module.exports = __webpack_public_path__ + "img/img-banner-top.583459a0.png";